/**
 * Initialize WP Block Heading functionality.
 * Wraps text in parentheses with a span element.
 */
export function initBlockHeadings() {
  $('.wp-block-heading').each(function() {
    var $heading = $(this);
    var html = $heading.html();
    
    // Check if there are parentheses in the content
    if (html.includes('(') && html.includes(')')) {
      // Replace text in parentheses with span-wrapped version
      var newHtml = html.replace(/(\([^)]+\))/g, '<span>$1</span>');
      $heading.html(newHtml);
    }
  });
}